module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/case-study-uniforming-b346dd250933e8d00031224345fd1e7f.jpg";